import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconSequence: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconSequence" {...props}>
    <svg height="100%" viewBox="0 0 18 19" fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.625 1.625H1.125L1.125 6.125H5.625V1.625ZM1.125 0.5C0.50368 0.5 0 1.00368 0 1.625V6.125C0 6.74632 0.50368 7.25 1.125 7.25H5.625C6.24632 7.25 6.75 6.74632 6.75 6.125V1.625C6.75 1.00368 6.24632 0.5 5.625 0.5H1.125Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.875 12.875H12.375V17.375H16.875V12.875ZM12.375 11.75C11.7537 11.75 11.25 12.2537 11.25 12.875V17.375C11.25 17.9963 11.7537 18.5 12.375 18.5H16.875C17.4963 18.5 18 17.9963 18 17.375V12.875C18 12.2537 17.4963 11.75 16.875 11.75H12.375Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9375 4.47266H7.875V3.34766H12.9375C14.1801 3.34766 15.1875 4.35502 15.1875 5.59766V7.8125C15.1875 9.05514 14.1801 10.0625 12.9375 10.0625H5.0625C4.44118 10.0625 3.9375 10.5662 3.9375 11.1875V13.4727C3.9375 14.094 4.44118 14.5977 5.0625 14.5977H10.125V15.7227H5.0625C3.81986 15.7227 2.8125 14.7153 2.8125 13.4727V11.1875C2.8125 9.94486 3.81986 8.9375 5.0625 8.9375H12.9375C13.5588 8.9375 14.0625 8.43382 14.0625 7.8125V5.59766C14.0625 4.97634 13.5588 4.47266 12.9375 4.47266Z"
        fill="currentColor"
      />
    </svg>
  </IconSVG>
)
